import { render } from "./ViewEmploiPage.vue?vue&type=template&id=068e9d61&ts=true"
import script from "./ViewEmploiPage.vue?vue&type=script&lang=ts"
export * from "./ViewEmploiPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__